import store from '../../../store';

export default () => store.model.user && !!store.model.user.deputyId;
